module.exports = __webpack_public_path__ + "static/media/icon-kenai-bot.81c6bfc5.svg";